// src/billing/billing.ts
import z from "zod";
var InvoiceSettings = z.object({
  taxId: z.object({
    country: z.string().optional(),
    type: z.string().optional(),
    value: z.string()
  }).optional(),
  additionalEmails: z.string().array()
});

export {
  InvoiceSettings
};
//# sourceMappingURL=chunk-BXCUPVNF.mjs.map